import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class OrderShipmentRefundSummaryResponse {
  @jsonMember(Boolean)
  public readonly fullyRefunded!: boolean;

  @jsonMember(Number)
  public readonly originalPrice!: number;

  @jsonMember(Number)
  public readonly refundedPrice!: number;

  @jsonMember(Number)
  public readonly currentPrice!: number;

  @jsonMember(Number)
  public readonly originalQuantity!: number;

  @jsonMember(Number)
  public readonly refundedQuantity!: number;

  @jsonMember(Number)
  public readonly currentQuantity!: number;
}
